'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFromAgent = undefined;

var _isSenderType = require('./isSenderType');

var _senderTypes = require('../constants/senderTypes');

var isFromAgent = exports.isFromAgent = (0, _isSenderType.isSenderType)(_senderTypes.AGENT);